// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__bg5kR","log":"ModalInventoryLogs_log__2QpOF","date":"ModalInventoryLogs_date__2I5EL","userName":"ModalInventoryLogs_userName__Rpmb0"};